import { supabase } from '../lib/supabase';

export interface NewsletterSubscriber {
  email: string;
  source?: string;
  gdpr_consent?: boolean;
}

export const subscribeToNewsletter = async (
  email: string, 
  source: string = 'footer'
): Promise<{ success: boolean; message: string }> => {
  try {
    // Check if Supabase is available
    if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
      console.log('📧 Newsletter signup (Supabase not configured):', email);
      return {
        success: true,
        message: 'Thank you for subscribing! We\'ll add you to our newsletter.'
      };
    }

    const { data, error } = await supabase
      .from('newsletter_subscribers')
      .insert([
        {
          email: email.toLowerCase().trim(),
          source,
          gdpr_consent: true
        }
      ])
      .select()
      .single();

    if (error) {
      // Handle duplicate email error
      if (error.code === '23505') {
        return {
          success: false,
          message: 'You\'re already subscribed to our newsletter!'
        };
      }
      
      console.error('Newsletter signup error:', error);
      return {
        success: false,
        message: 'Something went wrong. Please try again.'
      };
    }

    console.log('✅ Newsletter subscription successful:', data);
    
    return {
      success: true,
      message: 'Welcome! You\'re now subscribed to our newsletter.'
    };

  } catch (error) {
    console.error('Newsletter signup failed:', error);
    return {
      success: false,
      message: 'Something went wrong. Please try again.'
    };
  }
};

// Get newsletter subscribers count (admin only)
export const getNewsletterStats = async (): Promise<{ count: number; error?: string }> => {
  try {
    const { count, error } = await supabase
      .from('newsletter_subscribers')
      .select('*', { count: 'exact', head: true });

    if (error) {
      return { count: 0, error: error.message };
    }

    return { count: count || 0 };
  } catch (error) {
    return { count: 0, error: 'Failed to get stats' };
  }
};